import { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import PropTypes from "prop-types";
import { Button } from "@accredo/fe-shared/theme/components";
import { useSparteActions } from "../../hooks/useSparteActions.jsx";

SparteEditDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  sparte: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSaved: PropTypes.func.isRequired,
};

/**
 * Edits the description of a Sparte. The name is shown read-only: it belongs
 * to OpenViva and the next import overwrites it.
 */
export default function SparteEditDialog({ open, sparte, onClose, onSaved }) {
  const { updateDescription } = useSparteActions();
  const [beschreibung, setBeschreibung] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setBeschreibung(sparte?.beschreibung ?? "");
  }, [sparte]);

  const save = async () => {
    try {
      const result = await updateDescription(
        sparte.id,
        beschreibung.trim() || null,
        { setIsLoading: setIsSaving }
      );
      if (result) onSaved(result.data);
    } catch {
      // handleApiError has already shown the failure
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Sparte bearbeiten</DialogTitle>
      <DialogContent>
        <TextField
          label="Name"
          value={sparte?.name ?? ""}
          disabled
          fullWidth
          margin="normal"
          helperText="Der Name wird aus OpenViva übernommen."
        />
        <TextField
          label="Beschreibung"
          value={beschreibung}
          onChange={(event) => setBeschreibung(event.target.value)}
          fullWidth
          multiline
          minRows={3}
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button variant="tertiary" onClick={onClose}>
          Abbrechen
        </Button>
        <Button variant="primary" onClick={save} disabled={isSaving}>
          Speichern
        </Button>
      </DialogActions>
    </Dialog>
  );
}
